import { importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppComponent } from './app/app.component';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app/app.routes'; // ✅ your routes
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { DsImprintModule } from '@bmw-ds/components';
import { DsAccordionComponent } from '@bmw-ds/components';


bootstrapApplication(AppComponent, {
  providers: [
    provideAnimations(),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      FormsModule,
      DsAccordionComponent,
      DsImprintModule.forRoot({
        phone: '123498765',
        electronicContact: 'qwerty@bmwgroup.com',
      })
    ),
  ],
});
